import {
  Button,
  Drawer,
  Skeleton,
  Checkbox,
  TreeSelect,
  Card,
  Spin,
  ConfigProvider,
  Radio,
  Space,
} from "antd";
import { useState, useEffect, useRef } from "react";
import { useStoreUpdaterWithAPI } from "../../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../../Common/APIConstants";
import CustomDrawer from "../../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../../Elements/CustomSelect";
import SteamTreeSelectCustomWithSelectAll from "../../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
import SteamTreeSelectCustom from "../../../../../../Elements/TreeSelect/TreeSelectCustom";
import { calculateDateRangeFromDate } from "../../../../../../../Utils/DateConverstion";
import { useDispatch, useSelector } from "react-redux";
import * as echarts from "echarts";
import TreeSelectCustomWithSelectAll from "./TreeSelectCustomWithAllSelect";
import {
  FilterOutlined,
  // SunOutlined,
} from "@ant-design/icons";
import Empty from "../../../../../../CommonScreens/Empty";
import { setTheme } from "../../../../../../../Store/Reducers/ThemeAction";
import CustomThemeDrawer from "../../../../../../Elements/CustomThemeDrawer";
import { handledarkMode } from "../../../../../../Elements/DarkModeAction";
import { SunOutlined, MoonOutlined } from "@ant-design/icons";

const LiveChart = () => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const { loading, makeRequest } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState(); 
  const [converterGroupId, setConverterGroupId] = useState();
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false);
  const [openTheme, setOpenTheme] = useState(false);
  const [fromDateObj, setFromDateObj] = useState(null);
  const [fromDateString, setFromDateString] = useState();
  const [toDateObj, setToDateObj] = useState(null);
  const [toDateString, setToDateString] = useState();
  const [chartSkip, setChartSkip] = useState(true);

  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [paraError, setParaError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();

  const [chartLoading, setChartLoading] = useState(false);

  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState(
    []
  );
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] =
    useState([]);

  const [steamHistoricalData, setsteamHistoricalData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [parameter, setParameter] = useState([]);
  const [data1, setData1] = useState([]);
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [data3, setData3] = useState([]);
  const [loadings, setLoadings] = useState(true);
  const [loadingss, setLoadingss] = useState(true);
  const simulateLoading = (setLoadings) => {
    setLoadings(true);
    setTimeout(() => {
      setLoadings(false);
    }, 1000); // 2 seconds
  };
  useEffect(() => {
    simulateLoading(setLoadings);
  }, []);

  const mode = useSelector((state) => state.darkMode);
  const color = useSelector((state) => state.ThemeChange);
  console.log(color);
  const { isdarkMode } = mode;
  const dispatch = useDispatch();
  useEffect(() => {
    //  dispatch(setTheme('red'))
  }, []);

  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`,
    }).then((res) => {
      console.log(res);
      if (res && res.length > 0) {
        setflowSectionResData(res);
      }
    });

    makeRequest({
      type: APIConstants.GET,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.GET_ELECTRICAL_CONVERTER_DETAILS}`,
    }).then((res) => {
      console.log(res);
      if (res && res.length > 0) {
        setgetFlowConverterResData(res);
      }
    });

    makeRequest({
      type: APIConstants.POST,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`,
    }).then((res) => {
      console.log(res);
      if (res && res.length > 0) {
        setflowGroupDetailsResData(res);
      }
    });

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_PARAMETER_DETAILS}`,
    }).then((res) => {
      console.log(res);
      if (res && res.length > 0) {
        setParameter(res);
      }
    });
  }, []);

  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.ELECTRICAL_METERS_DETAILS}?ConverterID=${converterGroupId}`,
    }).then((res) => {
      console.log(res);
      if (res && res.length > 0) {
        setnsGetFlowConverterResData(res);
      }
    });

    makeRequest({
      type: APIConstants.POST,
      // GetFlowSteamGropeMeterDetails?GroupID=81
      url: `${APIConstants.ELECTRICAL_GROUP_METER_DETAILS}?GroupID=${converterGroupId}&Module=1`,
    }).then((res) => {
      console.log(res);
      if (res && res.length > 0) {
        setgetFlowSteamGroupMeterResData(res);
      }
    });
  }, [converterGroupId]);

  function transformDatas(inputData) {
    // Initialize arrays to store unique CreatedOn values and unique meter names
    const createdOn = [];
    const meterNames = [];

    // Collect unique CreatedOn values and meter names
    inputData.forEach((entry) => {
      const formattedDate = entry.CreatedOn.replace("T", " ");
      if (!createdOn.includes(formattedDate)) {
        createdOn.push(formattedDate);
      }
      if (!meterNames.includes(entry.METERNAME)) {
        meterNames.push(entry.METERNAME);
      }
    });

    // Initialize series array with meter names
    const series = meterNames.map((meterName) => ({
      name: meterName,
      type: "line",
      stack: "Total",
      data: Array(createdOn.length).fill(0), // Initialize with zeros for each CreatedOn value
    }));

    inputData.forEach((entry) => {
      const formattedDate = entry.CreatedOn.replace("T", " ");
      const dateIndex = createdOn.indexOf(formattedDate);
      const meterIndex = meterNames.indexOf(entry.METERNAME);

      if (dateIndex !== -1 && meterIndex !== -1) {
        series[meterIndex].data[dateIndex] += entry.KWHTotal;
      }
    });

    // Return the formatted structure
    return { series, createdOn, meterNames };
  }

  function prepareLineChartData(
    data,
    excludeFields = ["SiteName", "MeterId", "CreatedOn", "METERNAME"]
  ) {
    const series = [];
    const xAxisData = [];
    const metrics = {};
    const parameters = [];

    function removeDuplicates(inputArray) {
      console.log(inputArray);
      const seen = new Set();
      const result = [];

      inputArray.forEach((item) => {
        if (!seen.has(item)) {
          result.push(item);
          seen.add(item);
        }
      });

      return result;
    }

    data.forEach((entry) => {
      // Add unique timestamps to x-axis
      if (!xAxisData.includes(entry.CreatedOn.replace("T", " "))) {
        xAxisData.push(entry.CreatedOn.replace("T", " "));
      }

      // Iterate through all fields in the entry
      for (const key in entry) {
        if (!excludeFields.includes(key)) {
          // Group by METERNAME and metric (e.g., KWHTotal)
          const metricKey = `${entry.METERNAME}-${key}`;
          if (!metrics[metricKey]) {
            metrics[metricKey] = [];
          }
          metrics[metricKey].push(entry[key]);
          parameters.push(key);
        }
      }
    });

    // Prepare series for ECharts
    for (const [metricName, values] of Object.entries(metrics)) {
      series.push({
        name: metricName,
        type: "line",
        data: values,
      });
    }
    const para = removeDuplicates(parameters);
    console.log(para);
    console.log(xAxisData);
    const uniqueTimestamps = Array.from(
      new Set(
        xAxisData.map((ts) => {
          const [date, time] = ts.split(" "); // Split date and time
          const timeWithoutSeconds = time.split(":").slice(0, 2).join(":"); // Keep hour and minute
          return `${date} ${timeWithoutSeconds}:00`; // Append :00 for seconds
        })
      )
    );

    console.log(uniqueTimestamps);
    // Return the chart configuration

    return {
      xAxisData: uniqueTimestamps,
      series: series,
      parameter: para,
    };
  }

  const getResponse = (inputData) => {
    console.log(inputData);
    setIsLoading(true);

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_LIVE_CHART}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&Parameters=${inputData.Parameters}&FromDate=${inputData.FromDate}&Todate=${inputData.ToDate}`,
    }).then((res) => {
      console.log(res);
      if (res && res.length > 0) {
        setsteamHistoricalData(res);
        const data = transformDatas(res);
        console.log(data);
        setData(res);
        console.log(data.meterNames);
        // setData1(data.createdOn)
        // setData2(data.series)
        // setData3(data.meterNames)
        const test = prepareLineChartData(res);
        console.log(test);
        setData1(test.xAxisData);
        setData2(test.series);
        setLoadingss(false);
        // insertData(test.xAxisData, test.series)
        // setData3(test.parameter)
      }
      setIsLoading(false);
    });
  };

  const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList =
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList =
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList =
    (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
  const getFlowSteamGroupMeterList =
    (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };
  const showThemeDrawer = () => {
    setOpenTheme(true);
  };

  const onThemeClose = () => {
    setOpenTheme(false);
  };

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);

  const handleChangeSection = (changedValues) => {
    localStorage.setItem("flowSectionResData", JSON.stringify(changedValues));
    setSectionId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    setConverterGroupId(changedValues);
    localStorage.setItem("converterGroupId", JSON.stringify(changedValues));

    setSelectedMeterIds();
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    localStorage.setItem("selectedMeterIds", JSON.stringify(selectedValues));
    if (selectedValues) {
      setMeterError("");
    }
  };

  const handleTreeChange = (values) => {
    setSelectedValues(values);
    localStorage.setItem("selectedValues", JSON.stringify(values));

    if (values) {
      setParaError("");
    }
  };

  const setChartInputData = () => {
    const sectionId = localStorage.getItem("flowSectionResData");
    console.log(sectionId);
    const converterGroupId = localStorage.getItem("converterGroupId");
    console.log(converterGroupId);
    const selectedValue = localStorage.getItem("selectedValues");
    console.log(selectedValue);
    const para = JSON.parse(selectedValue)
      ?.map((id) => id)
      .join(",");
    console.log(para);
    const selectedMeterIds = localStorage.getItem("selectedMeterIds");
    console.log(selectedMeterIds);
    const ids = JSON.parse(selectedMeterIds)
      ?.map((id) => id)
      .join(",");
    console.log(ids);
    setSelectedMeterIds(JSON.parse(selectedMeterIds));
    setSelectedValues(JSON.parse(selectedValue));

    const currentDate = new Date();
    console.log(currentDate);
    const { from, to } = calculateDateRangeFromDate(currentDate, 15, 2);
    console.log(from, to);

    const inputData = {
      SectionID: Number(sectionId) || 1,
      ConverterorGroupID: Number(converterGroupId) || 0,
      Parameters: para || 0,
      MeterIds: ids || [],
      // FromDate: '2023-08-03 12:32:53',
      // ToDate: '2023-08-03 12:52:53',
      FromDate: from,
      ToDate: to,
    };
    console.log(inputData);
    getResponse(inputData);
    // const queryString = objectToQueryString(inputData);
    // setChartInput(queryString);
  };

  useEffect(() => {
    // Call the function every minute
    const interval = setInterval(() => {
      setChartInputData();
    }, 60000); // 60000 milliseconds = 1 minute

    // Cleanup the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setChartSkip(!chartSkip);
    // updateChart();
  }, [steamHistoricalData]);

  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds.length, "Meter");
    const paraError = validateInput(selectedValues.length, "Parameter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateInput(toDateString, "To Date");

    setSectionError(sectionError);
    setConverterError(converterError);
    setMeterError(meterError);
    setParaError(paraError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);

    if (
      !sectionError &&
      !converterError &&
      !meterError &&
      !paraError
      // && !parameterLenght
    ) {
      onClose();
      setChartLoading(true);
      setChartInputData();

      setIsLoading(!isLoading);
    }
  };

  useEffect(() => {
    if (loading || !data1 || !data2 || !chartInstance.current) return;

    const updateInterval = setInterval(() => {
      chartInstance.current.setOption({
        xAxis: {
          data: data1, // Updated x-axis data
        },
        series: data2, // Updated series data
      });
    }, 1000); // Update every second

    return () => clearInterval(updateInterval); // Cleanup on unmount
  }, [data1, data2, loading]);

  useEffect(() => {
    if (loading || !data1 || !data2) return; // Prevent chart rendering if data is unavailable

    const totalPoints = 15; // Total number of points in the input data
    const maxVisiblePoints = 15; // Maximum points to show on the chart
    let currentIndex = maxVisiblePoints; // Start updating from the next point

    // Prepare initial data
    let visibleXAxisData = data1.slice(0, maxVisiblePoints);
    let visibleSeriesData = data2.map((series) => ({
      ...series,
      data: series.data.slice(0, maxVisiblePoints),
    }));

    // Initialize chart instance
    if (!chartInstance.current) {
      chartInstance.current = echarts.init(chartRef.current);
    }

    // Set initial chart options
    const initialOptions = {
      backgroundColor: isdarkMode
        ? "#2d3748"
        : color.themeConfig.colorPrimaryShade,
      // title: {
      //   text: 'Live Trends',
      //   left: 'center',
      //   top: '5px',
      //   textStyle: {
      //     color: isdarkMode ? 'white' : 'black',
      //   },
      // },
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
        confine: true,
        position: function (point, params, dom, rect, size) {
          const [x, y] = point;
          const { contentSize, viewSize } = size;
          let xPos = x + 10;
          let yPos = y + 10;

          if (xPos + contentSize[0] > viewSize[0]) {
            xPos -= contentSize[0] + 20;
          }
          if (yPos + contentSize[1] > viewSize[1]) {
            yPos -= contentSize[1] + 20;
          }

          return [xPos, yPos];
        },
      },
      legend: {
        bottom: "0px",
        textStyle: {
          color: isdarkMode ? "white" : "black",
        },
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "25%",
        containLabel: true,
      },
      toolbox: {
        show: true,
        orient: "horizontal",
        left: "right",
        top: "top",
        feature: {
          mark: { show: true },
          magicType: { show: true, type: ["line", "bar"] },
          saveAsImage: { show: true },
        },
      },
      xAxis: [
        {
          type: "category",
          axisTick: { show: false },
          data: visibleXAxisData,
          axisLabel: {
            color: isdarkMode ? "white" : "black",
            fontSize: "10",
            fontWeight: "bold",
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          axisLabel: {
            color: isdarkMode ? "white" : "black",
            fontSize: "10",
            fontWeight: "bold",
          },
        },
      ],
      series: visibleSeriesData,
      dataZoom: [
        {
          type: "inside",
          start: 0,
          end: 100,
        },
      ],
    };

    chartInstance.current.setOption(initialOptions);

    // Update chart data every 15 seconds
    const updateData = () => {
      if (currentIndex < totalPoints) {
        // Remove the first value and add the next value
        visibleXAxisData.shift();
        visibleXAxisData.push(data1[currentIndex]);

        visibleSeriesData = visibleSeriesData.map((series, idx) => {
          const updatedData = [...series.data];
          updatedData.shift(); // Remove the first value
          updatedData.push(data2[idx].data[currentIndex]); // Add the new value
          return { ...series, data: updatedData };
        });

        // Update the chart with the new data
        chartInstance.current.setOption({
          xAxis: [
            {
              data: visibleXAxisData,
            },
          ],
          series: visibleSeriesData,
        });

        currentIndex++;
      } else {
        // Stop updating after all points are used
        console.log("All data has been added. Stopping updates.");
        clearInterval(interval);
      }
    };

    // Set interval to update every 15 seconds
    const interval = setInterval(updateData, 13000);

    // Handle window resize
    const resizeHandler = () => chartInstance.current.resize();
    window.addEventListener("resize", resizeHandler);

    return () => {
      clearInterval(interval); // Clear interval on cleanup
      window.removeEventListener("resize", resizeHandler);
      chartInstance.current.dispose();
      chartInstance.current = null;
    };
  }, [loadingss, isdarkMode, color]);

  const [selectedTheme, setSelectedTheme] = useState("blue");
  useEffect(() => {}, []);
  const handleChange = (e) => {
    dispatch(setTheme(e.target.value));
    setSelectedTheme(e.target.value);
  };
  const switchDarkMode = () => {
    isdarkMode
      ? dispatch(handledarkMode(false))
      : dispatch(handledarkMode(true));
  };
  console.log(color.themeConfig.colorPrimaryShade)

  return (
    <div
      id="chart"
      className={` relative bg-white p-4 rounded-md  dark ${isdarkMode ? "darkmode" : "whitemode"} `}
    >
      <div className="flex justify-between items-center px-2">
        <div className="text-3xl">
          <h4
            className={`text-left text-[30px] mb-5 dark ${isdarkMode ? "darkfont" : "whitemode"}`}
          >
            LIVE TRENDS
          </h4>
        </div>
        <Button
          size="large"
          className="flex justify-center items-center secondary-btn"
          style={{ "--secondary-color": color.themeConfig.secondaryColor,"--primary-color": color.themeConfig.colorPrimary }}
          onClick={() => setOpen(!open)}
        >
          <FilterOutlined /> Filter
        </Button>
        {/* <Button
          role="primary"
          size="large"
          className="flex justify-center items-center "
          onClick={() => setOpen(!open)}
        >
          <FilterOutlined /> Filter
        </Button> */}
      </div>

      {
        !data1.length > 0 && !loading && (
          <Empty open={open} setOpen={setOpen} isdarkMode={isdarkMode} />
        )
        // <div className="text-3xl">
        // <div className={`${!isdarkMode ? "text-black" : "text-white"}`}>No Data Available</div>
        // </div>
      }
        {loading && loadings && (
          <>
            <Skeleton active paragraph={{ rows: 6 }} />
          </>
        )}
      <Card
        className={`p-4 rounded-md shadow dark  ${!data1.length>0?"hidden":""}  ${isdarkMode ? "darkmode" : "whitemode  "} w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`}
        style={{
          position: "relative",
          overflow: "hidden",
          background: isdarkMode ? "" : color.themeConfig.colorPrimaryShade,
        }}
        bordered={false}
      >
        <div
          ref={chartRef}
          className={`${(!loading || !loadings) && data1.length > 0 ? "min-h-[80vh]" : "h-0"}  w-[100%]  mx-auto rounded-lg  mb-0 md:mb-0 px-3`}
        />
      </Card>

      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            // valueKey={sectionId === 1 ? "sitE_ID" : "groupID"}
            // nameKey={sectionId === 1 ? "sitename" : "department"}
            valueKey={sectionId === 1 ? "siteID" : "groupID"}
            nameKey={sectionId === 1 ? "siteName" : "department"}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          <TreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId == 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
            }
            idKey={"meterid"}
            valueKey={"meterid"}
            nameKey={"metername"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>
          <TreeSelectCustomWithSelectAll
            label="Parameters:"
            data={parameter}
            idKey="parameterid"
            nameKey="parametername"
            valueKey="parametername"
            selectedValues={selectedValues}
            onSelect={handleTreeChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {paraError}
            {/* {parameterLenght} */}
          </small>
        </div>
        <div className="flex justify-center mt-4">
          <Button
            type="primary"
            className=""
            onClick={() => {
              handleSubmit();
            }}
          >
            Search
          </Button>
        </div>
      </CustomDrawer>
    </div>
  );
};

export default LiveChart;
